import React from 'react';
import { 
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import MenuBar from './MenuBar';
import { useIntl } from "react-intl";

interface MainLayoutProps {
 loading?: boolean;
 loadingText?: string;
 onGoBack?: () => void;
 hideHomeButton?: boolean;
 hideBackButton?: boolean;
 hideSwitchUser?: boolean;
 hideUserAccount?: boolean;
 hideNorth?: boolean;
 hideWest?: boolean;
 hideEast?: boolean;
 hideMiddle?: boolean;
 north?: React.ReactElement;
 west?: React.ReactElement;
 east?: React.ReactElement;
 middle?: React.ReactElement;
 django?: Record<string,any>;
 backgroundColor?: string;
 northStyle?: Record<string,any>;
}

class MainLayout extends React.Component<MainLayoutProps, any> {

  static defaultProps = {
    backgroundColor: "",
    hideBackButton: true,
    hideSwitchUser: true,
    loadingText: "Loading",
    onGoBack: () => {},
    django: {},
    northStyle: {}
  };

  render() {
    const {
      django,
      loading,
      loadingText,
      hideHomeButton,
      hideBackButton,
      hideSwitchUser,
      hideUserAccount,
      onGoBack,
      hideNorth,
      hideWest,
      hideMiddle,
      hideEast,
      middle,
      east,
      west,
      north,
      className,
      backgroundColor,
      middleStyle,
      northStyle,
    }: any = this.props;

    return (
      <Dimmer.Dimmable dimmed={loading} style={{height: '100%'}} className={'MainLayout ' + this.props.className}>
        <Dimmer active={loading} inverted>
          <Loader inverted size='massive'>{loadingText}</Loader>
        </Dimmer>

        <div className='layout-vertical' style={{backgroundColor}}>
          <div className='north' style={northStyle}>
            {!hideNorth && (
              <MenuBar
                // @ts-ignore
                showAccount={!hideUserAccount}
                showHomeButton={!hideHomeButton}
                showBackButton={!hideBackButton}
                showSwitchUser={!hideSwitchUser}
                django={django}
                onGoBack={onGoBack}
                rightChildren={this.props.menuBarRightChildren}
              >
                {north}
              </MenuBar>
            )}
          </div>

          <div className='layout-horizontal'>
            {(!hideWest && west) && (
              <div className='west'>
                {west}
              </div>
            )}

            {!hideMiddle && (
              <div className='middle mainlayout' style={{ ...middleStyle }}>
                <div>
                  {middle}
                </div>
              </div>
            )}

            {(!hideEast && east) && (
              <div className='east'>
                {east}
              </div>
            )}
          </div>
        </div>
      </Dimmer.Dimmable>
    )
  }
}

export default MainLayout;